import React from 'react';
import HomepageHero from '../js/components/HomepageHero';
import UniversityBar from '../js/components/HomepageUniversityBar';
import {ProductOverview} from '../js/components/ProductOverview';
import DocumentHeader from '../js/components/DocumentHeader';
import {TestimonialSection} from '../js/components/TestimonialSection';
import {CtaSection} from '../js/pages/HomeLanding';
import {getBrandName} from '../js/components/Brand';

// Placeholder imports for new images
const CourseFeatureImage = '/images/features_schools_course.png';
const QuestionsFeatureImage = '/images/features_schools_questions.png';
const AnalyticsFeatureImage = '/images/features_schools_analytics.png';
const PracticeFeatureImage = '/images/duet_feedback.png';

const SchoolsPage = () => {
  const productFeatures = {
    lead: 'Our features',
    heading: 'The all-in-one platform for interview prep',
    productsList: [
      {
        name: 'Learn to interview confidently',
        description: (
          <p>
            Our courses help you
            <span className="text-indigo"> prepare for interviews </span>
            and
            <span className="text-indigo"> land more offers </span>
            . Learn what top recruiters and companies are looking for—including
            resumes, phone screens, behavioral interviews, and more.
          </p>
        ),
        image: CourseFeatureImage,
        ctaUrl: '/courses?tag=Behavioral',
        ctaText: 'Go to courses',
      },
      {
        name: 'Practice with peers and AI',
        description: (
          <p>
            Practice makes perfect. Use our new AI mock interview tool or
            connect with peers online to get actionable feedback and track
            your progress.
          </p>
        ),
        image: PracticeFeatureImage,
        ctaUrl: '/practice',
        ctaText: 'Practice now',
      },
      {
        name: 'Discover real interview questions',
        description: (
          <p>
            See the top questions asked by real companies with our question
            database containing over
            <span className="text-indigo"> 3,000+ questions</span>
            . Includes must-know behavioral, technical, and case studies.
          </p>
        ),
        image: QuestionsFeatureImage,
        ctaUrl: '/questions?category=behavioral',
        ctaText: 'Browse questions',
      },
      {
        name: 'Usage Analytics',
        description: (
          <p>
            All of our partnerships include detailed analytics
            {`for students so you can understand how ${getBrandName()} is`}
            helping your students.
          </p>
        ),
        image: AnalyticsFeatureImage,
        ctaUrl: '/pages/university',
        ctaText: 'Learn more',
      },
    ],
  };

  return (
    <div className="bg-white">
      <DocumentHeader title={`Interview Prep for Students - ${getBrandName()}`} />
      <HomepageHero
        headingText={(
          <>
            Everything you need
            <br />
            to ace your interviews
          </>
        )}
        ctaUrl="/pages/university"
      />
      <div className="mt-4 bg-gray-50">
        <UniversityBar />
      </div>
      <ProductOverview
        lead={productFeatures.lead}
        heading={productFeatures.heading}
        products={productFeatures.productsList}
      />
      <TestimonialSection />
      <CtaSection
        href="/signup"
        cta="Create your free account →"
        text="Ready to get started?"
      />
    </div>
  );
};

export default SchoolsPage;
